import { useQuery } from '@tanstack/react-query';
import { ApiResponse, QUERY_KEYS } from '../base-api';
import { getRegionList } from '../region.service';
import { RegionEntity } from '../types/region.type';

export const useRegionList = () => {
  return useQuery<ApiResponse<RegionEntity[]>>({
    queryKey: [QUERY_KEYS.REGION, QUERY_KEYS.LIST],
    queryFn: getRegionList,
  });
};
